import React from 'react'

function EmptyState({ children = 'No data available', className = '' }) {
  return (
    <div className={`text-center text-muted py-5 ${className}`.trim()}>
      {children}
    </div>
  )
}

export default EmptyState
